import lodashGet from "lodash/get";
import { httpPost } from "@/services/api.service";
import { ENDPOINT_TRANSLATOR } from "@/common/constants/api";
import { TRANSLATION_LANGUAGES } from "@/common/constants/language";

export { _translate as translate };
export { _getLanguage as getLanguage };
export { _translateKeywords as translateKeywords };

// This cache is used to hold onto the user's translations so if they have the same call to make
// we can just use the cached version instead of calling the server again for the same data. We
// have to do something like this because we can't easily cache the POST requests.
let cache = [];

const _translate = async (params) => {
  try {
    if (params.text && params.dest) {
      let text = params.text;
      if (!Array.isArray(params.text)) {
        text = [params.text];
      }

      let inputs = {
        text: text,
        dest: params.dest,
      };

      if (params.src) {
        inputs.src = params.src;
      }

      const INPUT_STRING = JSON.stringify(inputs);
      if (cache.length) {
        for (let i = 0; i < cache.length; i++) {
          const CACHED_ITEM = cache[i];
          if (INPUT_STRING === CACHED_ITEM.key) {
            return CACHED_ITEM.value;
          }
        }
      }

      const RESULT = await httpPost({
        url: ENDPOINT_TRANSLATOR,
        data: JSON.parse(INPUT_STRING),
      });

      if (RESULT) {
        const DATA = JSON.parse(RESULT);
        if (DATA && DATA.data && Array.isArray(DATA.data) && DATA.data.length) {
          cache.push({
            key: INPUT_STRING,
            value: DATA.data,
          });
          return DATA.data;
        }
      }
      return null;
    } else {
      return null;
    }
  } catch (error) {
    console.error("Issue translating", error);
    return null;
  }
};

const _getLanguage = (code) => {
  return TRANSLATION_LANGUAGES.find((language) => {
    return language.value === code;
  });
};

const _translateKeywords = async (keywords, preferences) => {
  if (keywords && Array.isArray(keywords) && keywords.length) {
    let words = [];
    keywords.forEach((item) => {
      if (item && item.key) {
        words.push(item.key);
      }
    });

    let params = {
      text: words,
      dest: "en",
    };
    if (lodashGet(preferences, "language.autoTranslateDest.value")) {
      params.dest = lodashGet(preferences, "language.autoTranslateDest.value");
    }

    const RESULT = await _translate(params);
    if (RESULT && Array.isArray(RESULT) && RESULT.length) {
      for (let i = 0; i < RESULT.length; i++) {
        const ITEM = RESULT[i];
        if (ITEM && ITEM.translatedText) {
          keywords[i].translation = ITEM.translatedText;
        } else {
          keywords[i].translation = keywords[i].key;
        }
      }
      return keywords;
    }
  }
  return null;
};
